import { Link } from "react-router-dom"
import SidebarDashboardBrand from "./sidebar_dashboard_brand"
import SidebarAccount from "./sidebar_account"
import { useContext } from "react"
import { AppContext } from "./context"
import { webAuth, baseUrl, client } from "./delcare"
import { useAuth0 } from "@auth0/auth0-react"



const NavbarSidebar = ({ showClose }) => {

    const { logout } = useAuth0()
    const { ww, path, setToken, offCanvas, popupSidebarType, neonUser } = useContext(AppContext)

    const logoutHandler = async (e) => {
        // e.preventDefault()
        // await webAuth.logout({
        //     returnTo: baseUrl+"/callback",
        //     clientID: client
        // });

        // window.localStorage.clear()
        // // setToken(null)




        logout({
            clientId: client,
            logoutParams: {
                returnTo: window.location.origin
            }
        })

    }

    return (

        <div className="navbar-sidebar d-flex justify-content-between flex-column h-100 w-100">
            <div>

                <div className={"d-flex justify-content-" + (showClose ? "between" : "center")}>
                    <Link to="/">
                        <div style={{ width: 130 }} className="m-3">
                            <img src={"/src/logo-dash.png"} className="w-100" />
                        </div>
                    </Link>
                    {showClose && <i onClick={() => offCanvas.hide()} className="bi bi-x-lg text-white fs-2 align-self-center me-3" style={{ cursor: "pointer" }}></i>}
                </div>

                <hr className="text-white m-0" />

                <div className="m-4 d-flex flex-column gap-3">


                    {path == ("/") ?
                        <SidebarDashboardBrand path={path} />
                        :
                        path.includes("/account") && !path.includes("/subscription") ?
                            <SidebarAccount path={path} />
                            :
                            <SidebarDashboardBrand path={path} />
                    }

                </div>



            </div>

            <div className="d-flex gap-2 p-4" onClick={logoutHandler} style={{ cursor: "pointer" }}>
                <div style={{ width: 35, height: 35, }} className="p-1 rounded off-icon">
                    <img src="/src/exit.svg" className="w-100 opacity-100 " />
                </div>

                <p className="text-white fs-6 m-0  align-self-center">Logout</p>
            </div>

        </div>





    )
}

export default NavbarSidebar